import React from 'react'

export default class ServiceActionsCell extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      service: props.service
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  render() {
    let { service } = this.state
    return (
      <>
        <a
          href="javascript:;"
          class="btn btn-icon btn-light btn-hover-primary btn-sm ml-1"
          title="Edit"
          onClick={() => this.props.onEditPressed(service) }
        >
          <i class="flaticon2-pen text-primary icon-sm"></i>
        </a>
      </>
    )
  }
}
